import axios from "axios";
import { Form } from "../components/shared/Form/Form";

class ServiceSupplierApplicationFormController {
  async getSupplierApplicationForm(formId: string): Promise<Form> {
    const response = await axios.get(`/api/supplier-application-form/${formId}`);
    return response.data;
  }

  async getSupplierApplicationFormForOrganization(): Promise<Form> {
    const response = await axios.get('/api/supplier-application-form/for-organization');
    return response.data;
  }

  async updateSupplierApplicationFormForOrganization(form: Form): Promise<void> {
    const response = await axios.put(`/api/supplier-application-form/for-organization`, form);
    return response.data;
  }
}

export const ServiceSupplierApplicationForm = new ServiceSupplierApplicationFormController(); 